// Plain-English names + help notes for the pipeline's accuracy metrics, so non-technical
// users aren't faced with jargon like "F1", "precision/recall", or "stream".

export const HELP = {
  accuracy:
    'Overall accuracy (0–100%). It balances two things: of the values the pipeline pulled out, ' +
    'how many were correct, and of the values it should have found, how many it actually found. ' +
    'Higher is better. (Technically: the F1 score.)',
  bestAccuracy:
    'The accuracy of the best-performing extraction method in the most recent benchmark. ' +
    'Click to open the benchmark.',
  madeUp:
    'Share of extracted values that don’t actually appear in the document — a sign the AI ' +
    'invented (“hallucinated”) them. Lower is better.',
  correctness: 'Of the values this method pulled out, the share that were correct. (Precision)',
  coverage: 'Of the values that should have been found, the share this method actually found. (Recall)',
  completeness: 'Share of the required fields that were found and verified in the document.',
  grounded: 'The value actually appears in the document text — verified, not invented.',
  methodComparison:
    'How the extraction methods compare on accuracy. Pattern-matching uses fixed rules; ' +
    'the AI methods read the document.',
  methods:
    'How a value is found: pattern-matching (fixed rules), open-source AI, or frontier AI.',
  cost: 'Estimated spend on paid AI calls. Rule-based and local methods are free.',
  energyEstimated: 'Estimated energy used by hosted AI APIs (we can’t measure theirs directly).',
  energyMeasured: 'Energy actually measured for models running locally on our own hardware.',
  accuracyTrend: 'How accuracy has changed over recent runs. Trending up is good.',
};

// Friendly names for the three internal "streams".
export const STREAM_LABELS: Record<string, string> = {
  deterministic: 'Rules',
  oss: 'Open-source AI',
  frontier: 'Frontier AI',
};

export const prettyStream = (s: string): string => STREAM_LABELS[s] || s;
